import SBEditable from "../../../components/sbEditable/sbEditable";
import styles from "./mastheadPanel.module.scss";
import Grid from "../../../components/grid/grid";
import ListingHeader from "../../../components/listingHeader/listingHeader";
import AuthorCard from "../../authorCard/authorCard";
import { useStoryblokMasthead } from "../../../hooks/useStoryblokMasthead";
import { useStoryblokGlobalSettings } from "../../../hooks/useStoryblokGlobalSettings"

/// Blok:mastheadPanel
// mastheadpanel:blok
///
/// header:string
function MastheadPanel({ blok }) {
  const [authors, isLoading] = useStoryblokMasthead();
  const globalSettings = useStoryblokGlobalSettings();

  if (!isLoading && authors.length === 0) {
    return null;
  }

  const authorCards = authors.map((author) => (
    <AuthorCard
      image={
        author.content.headshot?.filename
          ? author.content.headshot
          : globalSettings.default_author_image
      }
      key={author.uuid}
      name={author.content.name}
      byline={author.content.title}
      slug={author.slug}
    />
  ));

  return (
    <SBEditable blok={blok} withId={blok.anchor} withClass={styles.root}>
      {blok.header ? (
        <ListingHeader underlineColor={blok.header_underline_color}>
          <h2>{blok.header}</h2>
        </ListingHeader>
      ) : null}
      <Grid
        gridItems={authorCards}
        desktopColumns={3}
        tabletColumns={2}
        mobileColumns={1}
        gridFlowDirection="horizontal"
        hideUnderlineSingleColumn={true}
      />
    </SBEditable>
  );
}

export default MastheadPanel;
